"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CommandCell = _interopRequireDefault(require("./default/CommandCell"));
var _CommandCell2 = _interopRequireDefault(require("./modern/CommandCell"));
var _CommandCell3 = _interopRequireDefault(require("./pizza/CommandCell"));
var _CommandCell4 = _interopRequireDefault(require("./tropical/CommandCell"));
var _CommandCell5 = _interopRequireDefault(require("./street/CommandCell"));
var _CommandCell6 = _interopRequireDefault(require("./patisserie/CommandCell"));
var _CommandCell7 = _interopRequireDefault(require("./prestige/CommandCell"));
var _CommandCell8 = _interopRequireDefault(require("./neon/CommandCell"));
var _CommandCell9 = _interopRequireDefault(require("./minimal/CommandCell"));
var _CommandCell0 = _interopRequireDefault(require("./demo/CommandCell"));
var _CommandCell1 = _interopRequireDefault(require("./latino/CommandCell"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CommandCell = ({
  template_name = 'default',
  styles_properties,
  ...props
}) => {
  switch (template_name) {
    case 'modern':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CommandCell2.default, {
        template_name: template_name,
        styles_properties: styles_properties,
        ...props
      });
    case 'pizza':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CommandCell3.default, {
        template_name: template_name,
        styles_properties: styles_properties,
        ...props
      });
    case 'tropical':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CommandCell4.default, {
        template_name: template_name,
        styles_properties: styles_properties,
        ...props
      });
    case 'street':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CommandCell5.default, {
        template_name: template_name,
        styles_properties: styles_properties,
        ...props
      });
    case 'patisserie':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CommandCell6.default, {
        template_name: template_name,
        styles_properties: styles_properties,
        ...props
      });
    case 'prestige':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CommandCell7.default, {
        template_name: template_name,
        styles_properties: styles_properties,
        ...props
      });
    case 'neon':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CommandCell8.default, {
        template_name: template_name,
        styles_properties: styles_properties,
        ...props
      });
    case 'minimal':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CommandCell9.default, {
        template_name: template_name,
        styles_properties: styles_properties,
        ...props
      });
    case 'demo':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CommandCell0.default, {
        template_name: template_name,
        styles_properties: styles_properties,
        ...props
      });
    case 'latino':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CommandCell1.default, {
        template_name: template_name,
        styles_properties: styles_properties,
        ...props
      });
    case 'default':
    default:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CommandCell.default, {
        template_name: template_name,
        styles_properties: styles_properties,
        ...props
      });
  }
};
var _default = exports.default = CommandCell;